import { z } from 'zod/v3';
import { InputProcessingBatchSchema } from './InputProcessingBatchSchema';
import { InputProcessingErrorSchema } from './InputProcessingErrorSchema';
import { ProcessingEventDirectoryEntrySchema } from './ProcessingEventDirectoryEntrySchema';

export const InputProcessingEventDetailsSchema = z.object({
  processingEvent: ProcessingEventDirectoryEntrySchema,
  processingErrors: InputProcessingErrorSchema.array(),
  processingBatches: InputProcessingBatchSchema.array(),
});
